export const strategicThemes = [
    "Patient Access",
    "Patient Experience",
    "Patient Safety",
    "People",
    "Sustainability",
    "Systems & Partnership"
]

export const newStrategicTheme = [
    "People and Talent Development",
    "Financial Stewardship and Resource Optimisation",
    "Innovation and Digital Transformation",
    "Customer and Patient Experience Excellence",
    "Operational Excellence and Process Optimisation",
    "Sustainability and Ethical Governance",
    "Strategic Growth and Partnerships"
]


export const metricInformation = {
    "People and Talent Development": {
      "Recruitment": [
        "Time-to-Hire",
        "Cost-per-Hire",
        "Diversity of Hires",
        "Offer Acceptance Rate",
        "Hiring Source Effectiveness"
      ],
      "Retention": [
        "Employee Turnover Rate",
        "Retention Rate",
        "Employee Satisfaction",
        "Exit Interview Insights",
        "Voluntary vs. Involuntary Turnover"
      ],
      "Training & Development": [
        "Training Completion Rate",
        "Skills Improvement",
        "Time to Competency",
        "Training ROI",
        "Learning & Development (L&D) Participation Rate"
      ],
      "Employee Well-being": [
        "Absenteeism Rate",
        "Health & Wellness Program Utilization",
        "Employee Assistance Program (EAP) Usage",
        "Work-Life Balance Scores",
        "Burnout Rate"
      ],
      "Diversity, Equity, and Inclusion (DEI)": [
        "Diversity Ratio",
        "Pay Equity",
        "Promotion Equity",
        "DEI Training Completion",
        "Employee Perception of Inclusion"
      ]
    },
    "Financial Stewardship and Resource Optimisation": {
      "Cost Management": [
        "Cost Reduction",
        "Budget Compliance",
        "ROI on Investments",
        "Cost Avoidance",
        "Operational Efficiency"
      ],
      "Revenue Growth": [
        "Revenue Growth Rate",
        "New Revenue Streams",
        "Financial Efficiency",
        "Profit Margins",
        "Contribution Margin"
      ],
      "Resource Allocation": [
        "Resource Utilization",
        "Efficiency Gains",
        "Cost-Benefit Analysis",
        "Capital Expenditure (CapEx) vs. Operational Expenditure (OpEx)"
      ],
      "Financial Risk Management": [
        "Risk Exposure",
        "Risk Mitigation Success",
        "Credit Risk",
        "Market Risk",
        "Compliance with Financial Regulations"
      ]
    },
    "Innovation and Digital Transformation": {
      "Digital Transformation": [
        "Digital Adoption Rate",
        "IT Infrastructure Uptime",
        "Cybersecurity Incident Rate",
        "Automation Impact",
        "Cloud Utilization"
      ],
      "R&D and Product Development": [
        "Time-to-Market",
        "Innovation Rate",
        "Product Success Rate",
        "R&D Spending as a Percentage of Revenue",
        "Patent Filing Rate"
      ],
      "Process Improvement": [
        "Process Cycle Time",
        "Error Reduction",
        "Automation Impact",
        "Process Standardisation",
        "Lean Implementation Success"
      ],
      "Technology Integration": [
        "Integration Success Rate",
        "System Downtime",
        "Data Integrity",
        "User Adoption Rate of New Technologies"
      ]
    },
    "Customer and Patient Experience Excellence": {
      "Customer/Patient Satisfaction": [
        "Net Promoter Score (NPS)",
        "Customer Satisfaction Score (CSAT)",
        "Retention Rate",
        "Customer Effort Score (CES)",
        "Patient Satisfaction Surveys"
      ],
      "Service Quality": [
        "First Response Time",
        "Resolution Time",
        "Service Efficiency",
        "Service Level Agreement (SLA) Compliance",
        "Error Rate in Service Delivery"
      ],
      "Care Quality (Healthcare-specific)": [
        "Patient Outcome Rates",
        "Readmission Rates",
        "Compliance with Care Standards",
        "Patient Mortality Rates",
        "Length of Stay (LOS)"
      ],
      "Customer/Patient Retention": [
        "Churn Rate",
        "Customer Lifetime Value (LTV)",
        "Patient Follow-Up Compliance",
        "Loyalty Program Engagement"
      ]
    },
    "Operational Excellence and Process Optimisation": {
      "Process Efficiency": [
        "Process Cycle Time",
        "Throughput",
        "Operational Bottlenecks",
        "Lead Time",
        "Value Stream Mapping Results"
      ],
      "Supply Chain Management": [
        "Inventory Turnover",
        "Supply Chain Cost",
        "Delivery Accuracy",
        "Supplier Lead Time",
        "Supply Chain Disruption Frequency"
      ],
      "Quality Management": [
        "Defect Rate",
        "Rework Rate",
        "Compliance with Quality Standards",
        "Quality Audit Scores",
        "Customer/Patient Complaints"
      ],
      "Operational Risk Management": [
        "Operational Risk Incidents",
        "Incident Response Time",
        "Disaster Recovery Readiness",
        "Business Continuity Plan Effectiveness"
      ]
    },
    "Sustainability and Ethical Governance": {
      "Environmental Impact": [
        "Carbon Footprint Reduction",
        "Energy Efficiency",
        "Waste Management",
        "Water Usage",
        "Renewable Energy Utilization"
      ],
      "Social Responsibility": [
        "Community Engagement",
        "Ethical Compliance",
        "Volunteer Hours",
        "CSR Program Participation",
        "Philanthropic Contributions"
      ],
      "Governance": [
        "Compliance Rate",
        "Ethical Breach Incidents",
        "Supplier Audits",
        "Board Diversity",
        "Transparency in Reporting"
      ]
    },
    "Strategic Growth and Partnerships": {
      "Market Expansion": [
        "New Markets Entered",
        "Market Share Growth",
        "Revenue from New Markets",
        "Customer Acquisition Cost (CAC)",
        "Global Market Penetration"
      ],
      "Partnerships and Alliances": [
        "Number of Strategic Partnerships",
        "Partnership ROI",
        "Joint Venture Success",
        "Partnership Longevity",
        "Collaborative Innovation Outcomes"
      ],
      "Mergers and Acquisitions": [
        "Successful Integration Rate",
        "Acquisition ROI",
        "Time to Integration",
        "Synergy Realization",
        "Cultural Integration Success"
      ],
      "Strategic Initiatives": [
        "Strategic Project Completion Rate",
        "Alignment with Long-Term Goals",
        "Innovation Pipeline Success",
        "Competitive Positioning"
      ]
    }
  }
  



export const strategicThemesCategories = {
    "People and Talent Development": {
        description: "Build a culture where people feel supported, empowered, and engaged through recruitment, retention, development, and well-being.",
        categories: {
            "Recruitment": "Develop strategies to attract top talent, create a strong employer brand, and offer competitive opportunities.",
            "Retention": "Keep employees motivated and committed by improving job satisfaction, work-life balance, and recognition programs.",
            "Training & Development": "Promote continuous learning and upskilling to ensure employees are prepared for future challenges.",
            "Employee Well-being": "Enhance physical, mental, and emotional well-being by offering wellness initiatives and support programs.",
            "Diversity, Equity, and Inclusion (DEI)": "Foster a diverse and inclusive workplace where everyone feels valued and empowered to contribute."
        },
        themeClass:'pink__theme'
    },
    "Financial Stewardship and Resource Optimisation": {
        description: "Ensure financial responsibility and resource efficiency to drive long-term growth and stability.",
        categories: {
            "Cost Management": "Implement strategies to control expenses without sacrificing quality, ensuring financial sustainability.",
            "Revenue Growth": "Identify new revenue streams and market opportunities to drive financial growth while maintaining discipline.",
            "Resource Allocation": "Ensure optimal use of financial, human, and material resources to maximize organizational outcomes.",
            "Financial Risk Management": "Develop strategies to manage financial risks and protect the organization from market volatility and uncertainty."
        },
        themeClass:'green__theme'
    },
    "Innovation and Digital Transformation": {
        description: "Embrace innovation and digital solutions to enhance competitiveness, efficiency, and adaptability.",
        categories: {
            "Digital Transformation": "Use digital technologies to enhance operational efficiency, improve service delivery, and create new business models.",
            "R&D and Product Development": "Invest in research and development to bring new products and services to market, ensuring innovation leads to growth.",
            "Process Improvement": "Streamline processes to reduce inefficiencies and improve overall productivity.",
            "Technology Integration": "Ensure seamless integration of technologies across departments to drive better collaboration and performance."
        },
          themeClass:'blue__theme'
    },
    "Customer and Patient Experience Excellence": {
        description: "Deliver exceptional, personalized experiences to foster trust, loyalty, and satisfaction among customers and patients.",
        categories: {
            "Customer/Patient Satisfaction": "Capture and act on feedback to improve service quality and ensure customers and patients feel heard and valued.",
            "Service Quality": "Continuously enhance the quality of services delivered, ensuring high standards are maintained across all touchpoints.",
            "Care Quality (Healthcare-specific)": "Focus on improving the quality of healthcare services to deliver safer, more effective patient outcomes.",
            "Customer/Patient Retention": "Implement strategies to retain customers and patients by improving satisfaction, loyalty programs, and care coordination."
        },
          themeClass:'red__theme'
    },
    "Operational Excellence and Process Optimisation": {
        description: "Optimize processes and supply chains to improve efficiency, reduce waste, and mitigate risks for smooth operations.",
        categories: {
            "Process Efficiency": "Streamline workflows to reduce bottlenecks and inefficiencies, ensuring faster, more efficient operations.",
            "Supply Chain Management": "Optimize supply chains to ensure timely delivery of products and services while reducing costs and enhancing responsiveness.",
            "Quality Management": "Implement systems to ensure high-quality standards are met consistently across operations and service delivery.",
            "Operational Risk Management": "Identify and mitigate risks to ensure operational continuity and protect against disruptions."
        },
        themeClass:'orange__theme'
    },
    "Sustainability and Ethical Governance": {
        description: "Commit to sustainability and ethical governance by reducing environmental impact and ensuring compliance with governance standards.",
        categories: {
            "Environmental Impact": "Develop initiatives to reduce the organization’s carbon footprint, improve energy efficiency, and minimize waste.",
            "Social Responsibility": "Engage in community programs and initiatives that promote social well-being and align with corporate values.",
            "Governance": "Ensure compliance with ethical and regulatory standards, fostering a culture of transparency and accountability."
        },
        themeClass:'purple__theme'
    },
    "Strategic Growth and Partnerships": {
        description: "Drive growth through market expansion, partnerships, mergers, and strategic initiatives that enhance organizational capabilities.",
        categories: {
            "Market Expansion": "Explore new markets and customer segments to grow the organization’s footprint and drive revenue growth.",
            "Partnerships and Alliances": "Form and nurture partnerships that strengthen the organization’s ability to innovate and serve customers.",
            "Mergers and Acquisitions": "Pursue mergers and acquisitions that align with the organization’s growth strategy and long-term goals.",
            "Strategic Initiatives": "Implement large-scale strategic initiatives that drive organizational growth and align with overall vision and goals."
        },
        themeClass:'skyblue__theme'
    }
}



export const themeOptions = {
  pink__theme: "Pink Theme",
  green__theme: "Green Theme",
  blue__theme: "Blue Theme",
  red__theme: "Red Theme",
  orange__theme: "Orange Theme",
  purple__theme: "Purple Theme",
  skyblue__theme: "Sky Blue Theme",
  gray__theme: "Gray Theme",
  yellow__theme: 'Yellow Theme',
  teal__theme: 'Teal Theme',
  brown__theme: 'Brown Theme',
  lavender__theme: 'Lavender Theme',
  lightblue__theme: 'Light Blue Theme',
  lightgreen__theme: 'Light Green Theme',
  cyan__theme: 'Cyan Theme',
  peach__theme: 'Peach Theme',
  mint__theme: 'Mint Theme',
  lightpurple__theme: 'Light Purple Theme',
};

const themeColors = {
  pink__theme: "rgb(223, 0, 174)",
  green__theme: "rgb(102, 211, 135)",
  blue__theme: "blue",
  red__theme: "red",
  orange__theme: "orange",
  purple__theme: "blueviolet",
  skyblue__theme: "skyblue",
  gray__theme: "gray",
  yellow__theme: "yellow",
  teal__theme: "teal",
  brown__theme: "brown",
  lavender__theme: "lavender",
  lightblue__theme: "lightblue",
  lightgreen__theme: "lightgreen",
  cyan__theme: "cyan",
  peach__theme: "peach",
  mint__theme: "mint",
  lightpurple__theme: "lightpurple",
};

export const getThemeColor = (strategicTheme) => {
  const themeKey = Object.keys(themeOptions).find(key => 
    strategicTheme.themeClass?.includes(themeOptions[key])
  );
  return themeColors[themeKey] || "#09d966";
};

export const getThemeColorStyling = (strategicTheme) => {
  // const themeKey = Object.keys(themeColors).find(key => 
  //   strategicTheme.themeClass?.includes(themeColors[key])
  // );
  return themeColors[strategicTheme.themeClass] || "#09d966";
};